import React, { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const data = [
  { month: "Jun-24", fatality: 7 },
  { month: "Jul-24", fatality: 3 },
  { month: "Aug-24", fatality: 5 },
  { month: "Sep-24", fatality: 4 },
  { month: "Oct-24", fatality: 9 },
  { month: "Nov-24", fatality: 6 },
];
const dataMonth=['Jan','Feb','Mar','Apr','May','Jun','Jul',"Aug",'Sep','Oct','Nov','Dec']

const CustomBarChart = (props) => {
  return (
    <div style={{ width: "100%" }}>
      <h3 style={{  marginBottom: "20px",color:"rgb(0 0 0 / 73%)",fontSize:14,fontWeight:600,marginLeft:10 }}>{props?.title}</h3>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart
          data={[props?.month]}
          margin={{
            top: 20,
            right: 10,
            left: 10,
            bottom: 20,
          }}
        >
          {/* Add Grid */}
          <CartesianGrid strokeDasharray="2 2" vertical={false} />

          {/* X Axis */}
          <XAxis
            dataKey="month"
            tick={{ fontSize: 12, fontWeight: "bold" }}
            label={{
              value: "Months",
              position: "insideBottom",
              dy: 10,
              fontSize: 14,
              fontWeight: "bold",
            }}
          />

          {/* Y Axis */}
          <YAxis
            tick={{ fontSize: 12, fontWeight: "bold" }}
            label={{
              value: "Number",
              angle: -90,
              position: "insideLeft",
              fontSize: 14,
              fontWeight: "bold",
            }}
            domain={[0, 10]} // Keep domain fixed for consistency
          />

          {/* Tooltip */}
          {/* <Tooltip /> */}

          {/* Bars */}
          <Bar
            dataKey={`${props?.title}`}
            fill={props?.fill} // Exact green color
            radius={[4, 4, 0, 0]} // Rounded corners for top of bars
            barSize={30} // Adjust bar width for a clean design
          >
            {/* Add Labels on Bars */}
            <LabelList
              dataKey={`${props?.title}`}
              position="top"
              style={{ fontSize: 12, fontWeight: "bold" }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;